/**
 * Font constants for UI components
 *
 * Centralized font-related constants used across the application.
 */

export const FONT_CONSTANTS = {
  /** Custom display font used for the app logo */
  logoFamily: 'LogoFont, sans-serif',
} as const;

export type FontConstants = typeof FONT_CONSTANTS;
